import React, { useEffect, useState } from "react";
import "../../SignIn/SignIn.css";
import "../../ForgotPassword/ForgotPassword.css";
import "../../OTP/OTP.css";
import { Image, Container, Col, Row, Button } from "react-bootstrap";
import Logo from "../../../assets/communityXlogo.svg";
import { Link, useNavigate } from "react-router-dom";
import forgot from "../../../assets/forgot.png";
import OTPInput, { ResendOTP } from "otp-input-react";
import { MdArrowBack } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { OtpCheck } from "../../../ConditionChecks/ConditionChecks";
import ErrorLabel from "../../../Components/ErrorLabel/ErrorLabel";
import { ForgotPswdValidateOtp } from "../../../Utils/Api/ForgotPswdValidateOtp";
import Loader from "../../../Components/Loader/Loader";
import { toast } from "react-toastify";
import { VerifyOtpApi } from "../../../Utils/Api/VerifyOtpApi";
import { ServerError } from "../../../Utils/GlobalVariables/ToastifierVariables";
import { useSelector } from "react-redux";
import { SignUP } from "../../../Utils/Api/SignUP";

const VerifyOTP = () => {
  // Redux data 1
  const Reduxdata = useSelector((state) => state);

  const timeperiod = Reduxdata.OTPCounter.OTPCounterTime * 60;

  const [Otp, setOtp] = useState("");
  const [errDisplay, setErrDisplay] = useState("");
  const [loading, setLoading] = useState(false);

  // time counter
  const [timer, setTimer] = useState(timeperiod);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;

    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const onOtp = () => {
    setErrDisplay("");
  };

  const BuId = localStorage.getItem("BuUserId");

  const navigate = useNavigate();
  const ResendCode = Reduxdata.PersistedData.ResendCode.ResendCode;

  const SubmitHandler = (e) => {
    e.preventDefault();
    // console.log(Otp)
    const OtpValidation = OtpCheck(Otp);

    if (OtpValidation.input === "empty") {
      setErrDisplay(OtpValidation.err_display);
    }
    if (OtpValidation.input === "LessCharacters") {
      setErrDisplay(OtpValidation.err_display);
    }
    if (OtpValidation.validition === true) {
      let validateOtp = {
        bu_email: ResendCode.bu_email,
        otp: parseInt(Otp.trim()),
      };
      // console.log(validateOtp);
      VerifyOtp(validateOtp);
    }
  };

  const VerifyOtp = async (data) => {
    setLoading(true);
    const VerifyRes = await VerifyOtpApi(data, () => {
      navigate("/");
    });
    if (VerifyRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (VerifyRes.success === true) {
        toast.success(VerifyRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        localStorage.setItem("BuUserId", VerifyRes.bu_id);
        navigate("/signup/OTP/createpassword");
        setLoading(false);
      } else {
        toast.error(VerifyRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  const ResendCodeHandler = async () => {
    setLoading(true);
    const ResendCodeRes = await SignUP(ResendCode, () => {
      navigate("/");
    });
    if (ResendCodeRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (ResendCodeRes.success === true) {
        toast.success(ResendCodeRes.p_responseMessage, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setOtp("");
        setTimer(ResendCodeRes.timer * 60);
        setLoading(false);
      } else {
        toast.error(ResendCodeRes.p_responseMessage, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    let intervalId = null;

    if (timer > 0) {
      intervalId = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [timer]);

  useEffect(() => {
    setTimer(timeperiod);
  }, [timeperiod]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="main">
        <Container>
          <Row className="justify-content-md-center py-3 mobile-main">
            <Col md="6" className="page-content-left text-center hide-mobile">
              <Image
                loading="lazy"
                src={forgot}
                className="my-5 py-5 imgwidth-100"
              ></Image>
            </Col>
            <Col md="6" className="page-content-right">
              <div className="text-center mb-2 mt5">
                <Image loading="lazy" src={Logo} className="logo_Image"></Image>
                <p className="sign-second mt-5 pt-5 pb-2">
                  Verify One-time verification code
                </p>
              </div>
              <Row>
                <div className="signemail mt-3 pt-0 pb-3 text-center">
                  <p className="text-center recive-text">
                    Please enter the one-time verification code sent to your
                    registered email
                  </p>
                  <p
                    className="text-center recive-text"
                    style={{ fontStyle: "italic" }}
                  >
                    (If you haven't received the One-time verification code in
                    your inbox, we kindly request you to check your spam
                    folder.)
                  </p>
                  <OTPInput
                    className="otp-section mt-4 mb-2"
                    value={Otp}
                    onChange={(val) => {
                      setOtp(val);
                      onOtp();
                    }}
                    autoFocus
                    OTPLength={6}
                    otpType="number"
                    disabled={false}
                    maxTime={-1}
                  />
                  <div className="p-2">
                    {errDisplay ? (
                      <ErrorLabel ErrorDisplay={errDisplay} />
                    ) : timer !== 0 ? (
                      <p style={{ color: "#e66100" }}>
                        The One-time verification code sent will expire in{" "}
                        {formatTime(timer)} minutes
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                  <Link
                    onClick={ResendCodeHandler}
                    className="resendotp-section"
                  >
                    <p className="forgot-text">Resend Code</p>
                  </Link>
                  <Button
                    variant="primary"
                    onClick={SubmitHandler}
                    className="green-btn mt-2 mb-3 otp-submit"
                  >
                    Verify
                  </Button>
                </div>
                <Link to={"/signup"}>
                  <p className="text-center back-btn">
                    <MdArrowBack />
                    Back
                  </p>
                </Link>
                <p
                  style={{
                    textAlign: "center",
                    paddingTop: "50px",
                    color: "white",
                  }}
                >
                  (Do not refresh the page!)
                </p>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default VerifyOTP;
